import { DialogBody } from "@blueprintjs/core";
import { useWrapup } from "../wrapupcontext";
import Image from "next/image";
import { WrapupModuleCombatData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import pluralize from "@/src/util/pluralize";
import styles from './wrapup.module.css';

function pluralizeCountries(numCountries: number): string {
    return numCountries === 1
        ? `${numCountries} country`
        : `${numCountries} countries`
}

export default function WrapupModuleCombatComponent(): React.ReactNode {
    const { wrapupData } = useWrapup();

    const data = wrapupData.data.combat as WrapupModuleCombatData;

    return <DialogBody className={styles.dialogBody}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <h1>Combat</h1>
            <Image src='/images/emojis/angry.png' width={256} height={256} alt='dab' />
            <h3>
                Veni Vidi Vici. You took {pluralize(data.turns, 'turn')}, killed {pluralize(data.unitsKilled, 'unit')}, lost {pluralize(data.unitsLost, 'unit')} and captured {pluralizeCountries(data.countriesCaptured)}.
            </h3>
        </div>
    </DialogBody>
}
